/* eslint-disable prettier/prettier */
'use client';
import { useEffect, useState } from 'react';
import { Separator } from 'app/components/ui/separator';
import path from 'path';
import {
  LayoutDashboard,
  UserCog,
  Gem,
  Download,
  SquareKanban,
  ArrowLeftRight,
  LogOut,
  Coins,
  MonitorPlay,
  List,
  Users,
  Pencil,
  Star,
  ChevronLeft,
  CircleArrowLeft,
} from 'lucide-react';
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCourse } from '../slice/selectors';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [activePath, setActivePath] = useState<any>('');

  const navigate = useNavigate();

  const { courseId } = useParams();

  useEffect(() => {
    const path = window.location.pathname;
    const lastPath = path.split('/').pop();
    setActivePath(lastPath);
  }, []);

  const gotToRoute = (route: string) => {
    navigate(`/courses/${courseId}/${route}`);
  };

  return (
    <>
      <div className="flex gap-5">
        <aside className="w-full max-w-[220px] bg-white  dark:bg-transparent py-5">
          <ul className="space-y-2">
            <Link
              to={`/courses`}
              className={`px-2 py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium`}
            >
              <li className="flex items-center">
                <CircleArrowLeft className="w-4 h-4 mr-1" />
                Go Back To Courses
              </li>
            </Link>
            <div
              onClick={() => {
                gotToRoute('');
              }}
              className={`px-2 py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium ${
                activePath === '' ? 'bg-gray-100' : ''
              }`}
            >
              <li className="flex items-center">
                <Gem className="w-4 h-4 mr-1" />
                Overview
              </li>
            </div>

            <div
              onClick={() => {
                gotToRoute('contents');
              }}
              className={`px-2 py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium ${
                activePath === 'contents' ? 'bg-gray-100' : ''
              }`}
            >
              <li className="flex items-center">
                <MonitorPlay className="w-4 h-4 mr-1 " />
                Contents
              </li>
            </div>
            <div
              onClick={() => {
                gotToRoute('students');
              }}
              className={`px-2 py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium ${
                activePath === 'students' ? 'bg-gray-100' : ''
              }`}
            >
              <li className="flex items-center">
                <Users className="w-4 h-4 mr-1" />
                Students
              </li>
            </div>
            <div
              onClick={() => {
                gotToRoute('qna');
              }}
              className={`px-2 cusror-pointer py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium ${
                activePath === 'contents' ? 'bg-gray-100' : ''
              }`}
            >
              <li className="flex items-center">
                <Pencil className="w-4 h-4 mr-1" />
                Question & Answer
              </li>
            </div>
            <div
              onClick={() => {
                gotToRoute('reviews');
              }}
              className={`px-2 cursor-pointer py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium ${
                activePath === 'reviews' ? 'bg-gray-100' : ''
              }`}
            >
              <li className="flex items-center">
                <Star className="w-4 h-4 mr-1" />
                Reviews
              </li>
            </div>
            <div
              className={`px-2 py-2 block rounded-md hover:bg-gray-100 mx-3 text-[14px] font-medium ${
                activePath === 'contents' ? 'bg-gray-100' : ''
              }`}
            >
              <li className="flex items-center">
                <Pencil className="w-4 h-4 mr-1" />
                Edit
              </li>
            </div>
          </ul>
        </aside>
        <div className="w-full bg-white  dark:bg-transparent px-5 py-8">
          {children}
        </div>
      </div>
    </>
  );
}
